import { ItemJsEnv } from '../models/item_js_env';

const CommonModal = window._modal;

export class ExtendsModal extends CommonModal {
  model: ItemJsEnv;
  constructor(model: ItemJsEnv) {
    super('movie-data-micromodal-trigger');
    this.model = model;
  }

  onOpen(modal) {
    const itemMovieUrl = this.model.itemMovieUrl;
    if (modal.querySelector('iframe').src !== itemMovieUrl) {
      modal.querySelector('iframe').src = itemMovieUrl;
    }
    return true;
  }

  close(modal) {
    modal.querySelector('iframe').src = '';
  }
}
